// extracted by mini-css-extract-plugin
module.exports = {"logo":"Footer_logo__3rM57"};